export default __webpack_public_path__ + "static/media/black1.a5dbc752.gif";